import { render, staticRenderFns } from "./template.vue?vue&type=template&id=1ceff2fc&scoped=true&"
import script from "@/Views/Global/Login/component.ts?vue&type=script&lang=ts&"
export * from "@/Views/Global/Login/component.ts?vue&type=script&lang=ts&"
import style0 from "@/Views/Global/Login/style.scss?vue&type=style&index=0&id=1ceff2fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ceff2fc",
  null
  
)

export default component.exports